import { createGeneralPageEventsAndComponents } from "../technical/page-general";
import { expressAddClass, expressQuerySelector, expressRemoveClass, hasClass } from "../../common/html";
import { createNewsletterUnsubscribe } from "../molecules/newsletter";
import { createEmailPreferences, IMailFrequency } from "../technical/email-preferences";
import { getParameter } from "../../utils/querystring";
import { trackAccountPrefEvent } from "../../common/events";

window.addEventListener("DOMContentLoaded", () => {
	createGeneralPageEventsAndComponents();
	const unsubscribeContainerEl = expressQuerySelector<HTMLElement>(
		document,
		".technical-newsletter-unsubscribe-new",
		true,
	);
	const unsubscribeForm = expressQuerySelector<HTMLFormElement>(
		unsubscribeContainerEl,
		".technical-unsubscribe-form",
		false,
	);
	const emailPrefForm = expressQuerySelector<HTMLFormElement>(
		unsubscribeContainerEl,
		".technical-email-preferences-form",
		false,
	);
	const successMessageEl = expressQuerySelector<HTMLElement>(document, ".technical-unsubscribe-success", true);

	let email = getParameter("email");
	const personId = getParameter("personid");
	let unsubscribed = false;

	if (successMessageEl && !hasClass(successMessageEl, "u-hide")) {
		trackAccountPrefEvent("Unsubscribe from newsletter", { page: window.context.pageName });
		trackAccountPrefEvent("Unsubscribe from personal message", { page: window.context.pageName });
		unsubscribed = true;
	}
	const onSuccess = () => {
		const successMessageElDesc = expressQuerySelector<HTMLElement>(
			successMessageEl,
			".technical-unsubscribe-success-description",
			true,
		);
		const successMessageElDescEmail = expressQuerySelector<HTMLElement>(
			successMessageEl,
			".technical-unsubscribe-success-description-email",
			true,
		);
		const emailPrefEmailEl =
			emailPrefForm && expressQuerySelector<HTMLInputElement>(emailPrefForm, ".technical-preferences-mail", false);
		const unSubscribeEmailEl = expressQuerySelector<HTMLInputElement>(
			unsubscribeContainerEl,
			".technical-unsubscribe-mail",
			false,
		);

		if (!email) {
			email = (unSubscribeEmailEl && unSubscribeEmailEl.value) || (emailPrefEmailEl && emailPrefEmailEl.value);
		}
		if (emailPrefForm) {
			const emailPrefTitleEl = expressQuerySelector<HTMLElement>(emailPrefForm, ".a-typography--h2", true);
			const emailPrefSubTitleEl = expressQuerySelector<HTMLElement>(emailPrefForm, ".a-typography--h3", true);
			const emailPrefButtonEl = expressQuerySelector<HTMLElement>(emailPrefForm, ".technical-preferences-button", true);

			emailPrefTitleEl.innerText = successMessageEl.dataset.subtitle;
			expressAddClass(emailPrefTitleEl, "a-typography--blue");
			emailPrefButtonEl.innerText = successMessageEl.dataset.buttontext;
			expressAddClass(emailPrefSubTitleEl, "u-hide");
			expressAddClass(emailPrefEmailEl.parentElement, "u-hide");
			emailPrefEmailEl.value = email;
		}

		expressAddClass(successMessageElDesc, "u-no-margin-bottom");
		successMessageElDescEmail.innerText = email;
		changeHeaderImage(successMessageEl.dataset.headerimg);
		expressRemoveClass(successMessageEl, "u-hide");
		expressAddClass(unsubscribeForm, "u-hide");
		window.scrollTo({ top: 0, behavior: "smooth" });
		unsubscribed = true;
	};

	const changeHeaderImage = (newSrc?: string) => {
		if (newSrc) {
			const headerImageContainerEl = expressQuerySelector<HTMLElement>(document, ".technical-header-image", true);
			const headerImageEl = expressQuerySelector<HTMLImageElement>(headerImageContainerEl, "img", true);
			headerImageEl.src = newSrc;
		}
	};

	const onSubmit = () => {
		const successMessageEl = expressQuerySelector<HTMLElement>(document, ".technical-preferences-success", true);
		const successMessageElDesc = expressQuerySelector<HTMLElement>(
			successMessageEl,
			".technical-preferences-success-description",
			true,
		);
		const successMessageElDescEmail = expressQuerySelector<HTMLElement>(
			successMessageEl,
			".technical-preferences-success-description-email",
			true,
		);
		const successImageEl = expressQuerySelector<HTMLElement>(document, ".technical-preferences-success-image", true);
		const emailPrefEmailEl =
			emailPrefForm && expressQuerySelector<HTMLInputElement>(emailPrefForm, ".technical-preferences-mail", false);
		let unSubscribeEmailEl: HTMLInputElement;
		if (unsubscribeContainerEl)
			unSubscribeEmailEl = expressQuerySelector<HTMLInputElement>(
				unsubscribeContainerEl,
				".technical-unsubscribe-mail",
				false,
			);
		const unsubscribeSuccessMessageEl = expressQuerySelector<HTMLElement>(
			document,
			".technical-unsubscribe-success",
			true,
		);
		if (!email && !personId)
			email = (unSubscribeEmailEl && unSubscribeEmailEl.value) || (emailPrefEmailEl && emailPrefEmailEl.value);
		expressAddClass(successMessageElDesc, "u-no-margin-bottom");
		successMessageElDescEmail.innerText = email;
		changeHeaderImage(successMessageEl.dataset.headerimg);
		successMessageElDesc.classList.toggle("u-hide", !!personId);
		successMessageElDescEmail.classList.toggle("u-hide", !!personId);
		expressRemoveClass(successMessageEl, "u-hide");
		expressRemoveClass(successImageEl, "u-hide");
		unsubscribeContainerEl && expressAddClass(unsubscribeContainerEl, "u-hide");
		expressAddClass(unsubscribeSuccessMessageEl, "u-hide");
		window.scrollTo({ top: 0, behavior: "smooth" });
	};

	const hasUnsubscribed = () => {
		return unsubscribed || window.context.pageName === "Email preferences";
	};

	let emarsysData: string;
	const emarsys_email_id = getParameter("sc_src");
	const emarsys_contact_id = getParameter("sc_uid");
	const emarsys_launch_list_id = getParameter("sc_llid");
	if (emarsys_email_id || emarsys_contact_id || emarsys_launch_list_id)
		emarsysData = JSON.stringify({ emarsys_email_id, emarsys_contact_id, emarsys_launch_list_id });

	unsubscribeForm &&
		createNewsletterUnsubscribe(unsubscribeForm, { onSuccess, preFillLastUsedEmail: false }, emarsysData);
	emailPrefForm &&
		createEmailPreferences(emailPrefForm, {
			defaultMailFrequency: IMailFrequency.BiWeekly,
			onSubmit,
			trackEvent: true,
			hasUnsubscribed,
		});
});
